import { render, staticRenderFns } from "./UpdateTerm.vue?vue&type=template&id=5faae953&scoped=true"
import script from "./UpdateTerm.vue?vue&type=script&lang=js"
export * from "./UpdateTerm.vue?vue&type=script&lang=js"
import style0 from "./UpdateTerm.vue?vue&type=style&index=0&id=5faae953&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faae953",
  null
  
)

export default component.exports